import { useFormik } from "formik";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Form, Modal } from "reactstrap";
import { ExecutedActions, FieldForm, FieldValue } from "src/sdk";
import { UserService } from "src/services/UserService";



export interface DetailsProps {
    detailsItems: FieldValue,
    detailsActions: any,
    moduleRecordId: number,
    obj: FieldForm,
    modal_xlarge: boolean;
    setmodal_xlarge: (value: boolean) => void;
    tog_xlarge: () => void;
    setUpdateActions: (value: boolean) => void;
}

const service = new UserService();
export const Details: React.FC<DetailsProps> = ({
    detailsItems,
    detailsActions,
    moduleRecordId,
    obj,
    modal_xlarge,
    setmodal_xlarge,
    tog_xlarge,
    setUpdateActions,
}) => {

    const [action, setAction] = useState(null);

    const [actionId, setActionId] = useState(0);

    const [actionUsername, setActionUsername] = useState("");

    const [actionPassword, setActionPassword] = useState("");

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: obj,

        onSubmit: (values: any) => {
            const executedActionsData: ExecutedActions = {
                actionId: actionId,
                moduleRecordId: moduleRecordId as number,
                editedJson: JSON.stringify(values),
            }
            console.log(executedActionsData);

            service.executedActions(executedActionsData)
                .then(function (response) {
                    // let username = "mujo";
                    // let password = "mujorujanac2022+";
                    console.log(response.data)

                    let username = actionUsername;
                    let password = actionPassword;

                    let base64encodedData = Buffer.from(username + ':' + password).toString('base64');
                    //console.log(base64encodedData)
                    /////////////////////////////
                    service.filemakerAuthentication(action, base64encodedData)
                        .then(function (fmresponse) {
                            //console.log(fmresponse.data.response.token);
                            service.getActionLinkByPublicId(action, response.data.item.publicId, fmresponse.data.response.token)
                                .then(function (response2) {
                                    //console.log(response2);
                                    service.closeFilemakerSession(action, fmresponse.data.response.token, base64encodedData)
                                        .then(function (fmresponse2) {
                                            //console.log(fmresponse2);
                                            setUpdateActions(true);
                                            setmodal_xlarge(false);
                                            toast.success(`Message: ${JSON.parse(response2.data.response.scriptResult).message}  Status: ${JSON.parse(response2.data.response.scriptResult).status}`);
                                        })
                                        .catch(function (error) {
                                            console.log(error);
                                        })
                                })
                                .catch(function (error) {
                                    console.log(error);
                                })
                        })
                        .catch(function (error) {
                            console.log(error);
                        })

                })
                .catch(function (error) {
                    console.log(error);
                })
        }
    });

    return (
        <React.Fragment>
            <div className="container-fluid">
                <Modal
                 size="xl"
                    isOpen={modal_xlarge}
                    toggle={() => {
                        tog_xlarge();
                    }}
                    scrollable={true}
                >
                    <div className="modal-header">
                        <h5 className="modal-title mt-0">Details</h5>
                        <button
                            onClick={() => {
                                setmodal_xlarge(false);
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#808080";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#AAAAAA';
                            }}
                            data-dismiss="modal"
                            style={{ backgroundColor: "#AAAAAA", color: "#FFFFFF", border: 0, borderRadius: 60, gap: 5, width: 100, paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20, display: "flex" }}
                            type="button"
                        >
                            <i className={`bi-x-circle`} />
                            Close
                        </button>
                    </div>
                    <div className="modal-body">
                        <Form
                            onSubmit={(e: any) => {
                                e.preventDefault();
                                validation.handleSubmit();
                                return false;
                            }}
                        >
                            <>
                                {detailsItems.map((element: any, index: any) => {
                                    return (
                                        <div style={{ marginTop: 3, border: '1px solid #DEDEDE' }}>
                                            <div className="row" style={{ marginLeft: 0, marginRight: 0, backgroundColor: "#F7F7F7" }}>
                                                <p style={{ fontSize: 15, marginBottom: 5 }}>{element.label}</p>
                                            </div>
                                            <div>
                                                <p style={{ marginLeft: 10, marginTop: 5, fontWeight: "bold" }}>
                                                    {Object.values(obj)[index]}
                                                </p>
                                                {/* {(() => {
                                                        if (element.type === "date") {
                                                        return (
                                                            <Input
                                                                id={element.name}
                                                                name={element.name}
                                                                type="date"
                                                                style={{border:0, fontWeight:"bold"}}
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                defaultValue={moment(Object.values(obj)[index]).format('YYYY-MM-DD')}
                                                                required
                                                            />
                                                        )
                                                        } else if (element.type === "boolean") {
                                                        return (
                                                            <Input
                                                                id={element.name}
                                                                name={element.name}
                                                                type="text"
                                                                style={{border:0, fontWeight:"bold"}}
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                defaultValue={Object.values(obj)[index]}
                                                                required
                                                            />
                                                        )
                                                        } else if (element.type === "number") {
                                                            return (
                                                                <Input
                                                                    id={element.name}
                                                                    name={element.name}
                                                                    type="number"
                                                                    style={{border:0, fontWeight:"bold"}}
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    defaultValue={Object.values(obj)[index]}
                                                                    required
                                                                />
                                                            )
                                                        }
                                                        else {
                                                        return (
                                                            <Input
                                                                id={element.name}
                                                                name={element.name}
                                                                type="text"
                                                                style={{border:0, fontWeight:"bold"}}
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                defaultValue={Object.values(obj)[index]}
                                                                required
                                                            />
                                                        )
                                                        }
                                                    })()} */}
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        </Form>
                        <hr />
                        <div style={{ marginTop: 10 }}>
                            {detailsActions.map((element: any, index: any) => {
                                return (
                                    <div className="row" style={{ marginLeft: 0, marginRight: 0, marginTop: 5 }}>
                                        <button key={index}
                                            style={{ width: "100%", borderRadius: 60, border: 0, backgroundColor: "#95CBB2", color: "#FFFFFF" }}
                                            className="btn btn-primary btn-block"
                                            type="button"
                                            onClick={() => {
                                                const executedActionsData: ExecutedActions = {
                                                    actionId: element.actionId,
                                                    moduleRecordId: moduleRecordId as number,
                                                    editedJson: JSON.stringify(obj),
                                                }
                                                console.log(executedActionsData);
                                                service.executedActions(executedActionsData)
                                                    .then(function (response) {
                                                        // let username = "mujo";
                                                        // let password = "mujorujanac2022+";
                                                        console.log(response);
                                                        console.log(element.username)
                                                        console.log(element.password)

                                                        let username = element.username;
                                                        let password = element.password;

                                                        let base64encodedData = Buffer.from(username + ':' + password).toString('base64');
                                                        console.log(base64encodedData)
                                                        /////////////////////////////
                                                        service.filemakerAuthentication(element, base64encodedData)
                                                            .then(function (fmresponse) {
                                                                console.log(fmresponse.data);
                                                                service.getActionLinkByPublicId(element, response.data.item.publicId, fmresponse.data.response.token)
                                                                    .then(function (response2) {
                                                                        console.log(response2);
                                                                        service.closeFilemakerSession(element, fmresponse.data.response.token, base64encodedData)
                                                                            .then(function (fmresponse2) {
                                                                                console.log(fmresponse2);
                                                                                console.log(JSON.parse(response2.data.response.scriptResult).message)
                                                                                console.log(JSON.parse(response2.data.response.scriptResult).status)
                                                                                setUpdateActions(true);
                                                                                // toast.success("Action executed!");
                                                                                toast.success(`Message: ${JSON.parse(response2.data.response.scriptResult).message}  Status: ${JSON.parse(response2.data.response.scriptResult).status}`);
                                                                            })
                                                                            .catch(function (error) {
                                                                                console.log(error);
                                                                            })
                                                                    })
                                                                    .catch(function (error) {
                                                                        console.log(error);
                                                                    })
                                                            })
                                                            .catch(function (error) {
                                                                console.log(error);
                                                            })
                                                    })
                                                    .catch(function (error) {
                                                        console.log(error);
                                                    })
                                            }
                                            }
                                        >
                                            {element.name}
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Modal>
                {/* <Modal
                    isOpen={modal_fullscreen}
                    toggle={() => {
                        tog_fullscreen();
                    }}
                    scrollable={true}
                >
                    <div className="modal-header">
                        <p className="modal-title text-left" style={{fontSize: 20, fontWeight:"bold"}}>Details</p>
                        <button
                            onClick={() => {
                                setmodal_fullscreen(false);
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor="#808080";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#AAAAAA';
                            }}
                            data-dismiss="modal"
                            style={{backgroundColor:"#AAAAAA", color:"#FFFFFF", border:0, borderRadius:60, gap:5, width:100, paddingTop:5, paddingBottom:5, paddingLeft: 20, paddingRight:20, display:"flex"}}
                            type="button"
                        >
                            <i className={`bi-x-circle`}/>
                            Close
                        </button>
                    </div>
                    <div className="modal-body">
                        <Form
                            onSubmit={(e: any) => {
                                e.preventDefault();
                                validation.handleSubmit();
                                return false;
                            }}
                        >
                            <Container fluid>
                                <>
                                    {detailsItems.map((element: any, index: any) => {
                                        return (
                                            <Row key={index} style={{height:30}}>
                                                <Row style={{height:20}}>
                                                    <h5>{element.label}:</h5>
                                                </Row>
                                                <Row style={{height:20}}>
                                                    <>
                                                    {(() => {
                                                        if (element.type === "date") {
                                                        return (
                                                            <Input
                                                                id={element.name}
                                                                name={element.name}
                                                                className="form-control"
                                                                type="date"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                defaultValue={moment(Object.values(obj)[index]).format('YYYY-MM-DD')}
                                                                required
                                                            />
                                                        )
                                                        } else if (element.type === "boolean") {
                                                        return (
                                                            <Input
                                                                id={element.name}
                                                                name={element.name}
                                                                className="form-control"
                                                                type="text"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                defaultValue={Object.values(obj)[index]}
                                                                required
                                                            />
                                                        )
                                                        } else if (element.type === "number") {
                                                            return (
                                                                <Input
                                                                    id={element.name}
                                                                    name={element.name}
                                                                    className="form-control"
                                                                    type="number"
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    defaultValue={Object.values(obj)[index]}
                                                                    required
                                                                />
                                                            )
                                                        }
                                                        else {
                                                        return (
                                                            <Input
                                                                id={element.name}
                                                                name={element.name}
                                                                className="form-control"
                                                                type="text"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                defaultValue={Object.values(obj)[index]}
                                                                required
                                                            />
                                                        )
                                                        }
                                                    })()}
                                                    </>
                                                </Row>
                                            </Row>
                                        );
                                    })}
                                    <Row>
                                        <Col className="p-2" style={{ textAlign: "center" }}>
                                            {detailsActions.map((element: any, index: any) => {
                                                return (
                                                    <button key={index}
                                                        style={{ marginRight: "20px" }}
                                                        className="btn btn-primary btn-block"
                                                        type="submit"
                                                        onClick={() => {
                                                            setActionId(element.actionId)
                                                            setActionUsername(element.username)
                                                            setActionPassword(element.password)
                                                            setAction(element || null)
                                                        }}
                                                    >
                                                        {element.name}
                                                    </button>
                                                );
                                            })}
                                            <button
                                                type="button"
                                                style={{ marginRight: "20px" }}
                                                onClick={() => {
                                                    tog_fullscreen();
                                                }}
                                                className="btn btn-secondary"
                                                data-dismiss="modal"
                                            >
                                                Cancel
                                            </button>
                                        </Col>
                                    </Row>

                                </>
                            </Container>
                        </Form>
                    </div>
                </Modal> */}
            </div >
        </React.Fragment >
    );
}

Details.propTypes = {

};
export default withTranslation()(Details);
